@if (isVisible) {
  <div
    class="concierge-panel"
    [class.concierge-panel--open]="isOpen"
    role="dialog"
    aria-label="Concierge"
    [attr.aria-hidden]="!isOpen"
  >
    @if (iframeUrl) {
      <button type="button" class="concierge-panel-close" aria-label="Close" (click)="close()">
        <img src="assets/concierge/close.svg" width="16" height="16" alt="" aria-hidden="true" />
      </button>
      <iframe
        class="concierge-iframe"
        title="Concierge"
        [src]="iframeUrl"
        allow="microphone; camera; fullscreen; autoplay; clipboard-write; display-capture"
        referrerpolicy="strict-origin-when-cross-origin"
      ></iframe>
    }
  </div>

  <button
    type="button"
    class="concierge-fab"
    [attr.aria-expanded]="isOpen"
    aria-label="Open chat"
    (click)="toggle()"
  >
    <span class="concierge-fab-orb" aria-hidden="true"></span>
    <img class="concierge-fab-icon" src="assets/concierge/sms.svg" width="27" height="29" alt="" aria-hidden="true" />
    <app-unread-count-badge [count]="(unreadCount$ | async) ?? 0"></app-unread-count-badge>
  </button>
}
